const toNumber = (v: unknown): number | null => {
  if (v == null || v === "") return null;
  const n = typeof v === "number" ? v : parseFloat(String(v));
  return Number.isFinite(n) ? n : null;
};

/** Fixed two decimals (money, hours): `12.5` → `"12.50"`. Empty string when missing. */
export const formatFixed2 = (v: unknown): string => {
  const n = toNumber(v);
  return n == null ? "" : n.toFixed(2);
};

/** At most two decimals, trailing zeros trimmed (quantities): `12.50` → `"12.5"`, `3` → `"3"`. */
export const formatMax2 = (v: unknown): string => {
  const n = toNumber(v);
  return n == null ? "" : String(Math.round(n * 100) / 100);
};

/** Parses user input accepting both `,` and `.` as decimal separator. */
export const parseDecimalInput = (s: string): number | null => {
  const t = s.trim().replace(",", ".");
  if (t === "") return null;
  const n = parseFloat(t);
  return Number.isFinite(n) ? n : null;
};
